export const MENU_HIDDEN_PATHS: string[] = [];

export const getMenuRoutes = <T extends { path: string }>(routes: T[]): T[] =>
  routes.filter(({ path }) => !MENU_HIDDEN_PATHS.includes(path));
